import { render, staticRenderFns } from "./mobile-menu.vue?vue&type=template&id=1248ae1a&scoped=true"
import script from "./mobile-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-menu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mobile-menu.vue?vue&type=style&index=0&id=1248ae1a&prod&lang=less"
import style1 from "./mobile-menu.vue?vue&type=style&index=1&id=1248ae1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248ae1a",
  null
  
)

export default component.exports